<h1 *ngIf="data.title" mat-dialog-title>{{ data.title }}</h1>
<span *ngIf="data.message" mat-dialog-content>{{ data.message }}</span>

<mat-nav-list
        *ngFor="let button of data.buttons; index as i">

    <!-- TODO: IMPLEMENT EXTERNAL LINKING: target="_blank" [href]="button.link" -->
    <a mat-list-item
       (click)="data.buttonClick(button.value)"
    >
        <span mat-line>{{button.title}}</span>
        <span *ngIf="button.note" mat-line>{{button.note}}</span>
    </a>
</mat-nav-list>
